import { Alert, Badge, Drawer, message, Tooltip } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessage } from '@fortawesome/free-solid-svg-icons';
import { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Core } from "../components/infrastructure/core";
import { IPanelInfo, IPanelMessage, IResultSet } from "../components/infrastructure/models";
import { UserPanelHubConnector, IUserPanelHubDto } from '../components/signalR/signalRUserPanelConnection';
import AppContext, { AppContextProps } from "../components/infrastructure/appContext";
import { InfoCircleOutlined } from '@ant-design/icons';

const PnlMsg = (props: IPanelMessage) => {
    let { content }: any = props;

    const numbers = content.match(/\d+/g);
    for (let i = 0; i < numbers.length; i++) {
        if (!!numbers[i] && numbers[i].length >= 6)
            content = content.replace(numbers[i], `<b>${numbers[i]}</b>`);
        if (i === numbers.length - 1)
            content = Core.decode(content);
    }

    return (
        <Alert
            key={props.rowGuid}
            style={{ padding: 5, marginBottom: 6, boxShadow: 'rgb(0 0 0 / 12%) 0px 0px 5px 2px' }}
            description={content}
            type={"info"}
            icon={<InfoCircleOutlined style={{ fontSize: 16 }} />}
            showIcon
        />
    );
}

const UserPanel = () => {
    const { getPanelInfo, setPanelInfo, getUserInfo } = useContext<AppContextProps>(AppContext);
    const panelInfo = getPanelInfo();
    const userInfo = getUserInfo();

    const [drawerCollapsed, setDrawerCollapsed] = useState(true);
    const selectedMessageId = useRef<any>(undefined);
    const panelInfoRef = useRef<IPanelInfo>(panelInfo);

    const changeDrawerCollapse = () => {
        setDrawerCollapsed(!drawerCollapsed);
    }

    const subscribeUserPanelHubEvanthandler = (userPanelHubDto: IUserPanelHubDto) => {
        if (!!userPanelHubDto.MessageGuid) {
            let messageContent = null;
            for (var key in userPanelHubDto.Data) {
                let msg = userPanelHubDto.Data[key].find(m => m.RowGuid === userPanelHubDto.MessageGuid);
                if (!!msg)
                    messageContent = msg.Message;
            }

            if (!!messageContent)
                showNotification(userPanelHubDto.MessageGuid, messageContent);

            message.info({
                content: messageContent ?? 'پیام جدید دارید',
                style: { cursor: 'pointer' },
                onClick: () => {
                    selectedMessageId.current = userPanelHubDto.MessageGuid;
                    if (drawerCollapsed)
                        changeDrawerCollapse();
                }
            });
        }

        setUserPanelNotification(userPanelHubDto.Data);
    }

    const getUserPanelWaitingDamageCasesCount = async () => {

        await Core.callApi({
            url: `home/getWaitingNotifications`,
            onSuccess: (result: IResultSet<any>) => {
                if (result.ValidationState.Successful)
                    setUserPanelNotification(result.Data);
            }
        });
    }

    const setUserPanelNotification = (data: { [key: string]: { Message?: string; Id?: number; RowGuid: any; Path: string; }[] }) => {

        let newData = [];

        for (let key in data) {
            for (let i = 0; i < data[key].length; i++) {
                newData.push({ key, ...data[key][i] });
            }
        }

        panelInfoRef.current.data = newData;
        setPanelInfo(panelInfoRef.current);
    }

    const notify = (messageGuid: any, messageContent: string) => {
        var options: NotificationOptions = {
            body: messageContent ?? 'پیام جدید دارید',
            dir: 'rtl',
            vibrate: 1,
            icon: '/logo.png',
        };

        const notification = new Notification('شرکت خدمات تجهیزات الکترونیک زبده', options);
        notification.onclick = function () {
            window.parent.focus();
            notification.close();
            setTimeout(() => {
                selectedMessageId.current = messageGuid;
                if (drawerCollapsed)
                    changeDrawerCollapse();
            }, 100);
        }
    };

    const showNotification = (messageGuid: any, messageContent: string) => {
        if ("Notification" in window) {
            Notification.requestPermission()
                .then(permission => {
                    if (permission === "granted" && document.visibilityState !== "visible")
                        notify(messageGuid, messageContent);
                });
        }
    };

    useEffect(() => {
        if (!userInfo?.extraVariables["EvaluatorId"] && !userInfo?.extraVariables["PolicyholderId"])
            return;

        const { subscribeEvents, unsubscribeEvents } = new UserPanelHubConnector();
        subscribeEvents(subscribeUserPanelHubEvanthandler);

        getUserPanelWaitingDamageCasesCount();

        return () => {
            setPanelInfo({ data: [] });
            unsubscribeEvents();
        }
    }, []);

    const msgs = panelInfo.data.filter(m => !!m.Id && !!m.Message).map(message => {
        return {
            content: message.Message!, id: message.Id!, rowGuid: message.RowGuid, link: '/refresh?' + encodeURIComponent(`/${message.Path}?defaultId=${message.Id}`)
        } as IPanelMessage
    });

    const messages = msgs.map(m =>
        <div key={m.rowGuid}>
            {
                m.link ?
                    <Tooltip title="برای مشاهده کلیک نمایید" >
                        <Link
                            to={m.link}
                            onClick={changeDrawerCollapse}
                            ref={node => {
                                if (node && !drawerCollapsed && m.rowGuid === selectedMessageId.current) {
                                    selectedMessageId.current = undefined;
                                    node.click();
                                }
                            }}
                        >
                            <PnlMsg {...m} />
                        </Link>
                    </Tooltip>
                    :
                    <PnlMsg {...m} />
            }
        </div>
    );
    return (
        <>
            {
                msgs.length > 0 &&
                <Tooltip title="پیامها">
                    <Badge count={msgs.length} size="small">
                        <FontAwesomeIcon icon={faMessage} size={'2x'} onClick={changeDrawerCollapse} style={{ verticalAlign: 'middle', cursor: 'pointer' }} />
                    </Badge>
                </Tooltip>
            }
            <Drawer
                title="پیامها"
                placement={'left'}
                closable={true}
                onClose={changeDrawerCollapse}
                visible={!drawerCollapsed}
                key={'notification-drawer'}
                bodyStyle={{ padding: 0 }}
            >
                <div className="custom-scroll" style={{ padding: 6, height: "100%" }}>
                    {messages}
                </div>
            </Drawer>
        </>
    );
};

export default UserPanel;